import React from 'react';
import Hero from '../components/Hero';
import { useSEO } from '../hooks/useSEO';

const HomePage: React.FC = () => {
  useSEO({
    title: 'Synergy - Un nuovo modo di comprare materiali edili edili',
    description: 'Synergy connette imprese edili e fornitori certificati per comprare e vendere materiali a prezzi migliori. Risparmia sui materiali edili grazie agli ordini collettivi.',
    keywords: 'materiali edili, forniture edili, sconti materiali, fornitori certificati, edilizia, risparmio edilizia, acquisti collettivi, vendere materiali edili, aggregazione ordini',
    ogTitle: 'Synergy - Un nuovo modo di comprare materiali edili edili',
    ogDescription: 'Connetti la tua impresa edile con fornitori certificati per ottenere prezzi migliori e forniture più affidabili.',
    canonicalUrl: 'https://synergyedilizia.com',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Synergy",
      "description": "Piattaforma che connette imprese edili e fornitori certificati per comprare e vendere materiali a prezzi migliori",
      "url": "https://synergyedilizia.com",
      "logo": "https://synergyedilizia.com/assets/logo.svg",
      "sameAs": [],
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "availableLanguage": "Italian"
      }
    }
  });

  return (
      <Hero />
  );
};

export default HomePage;
